import {useEffect} from 'react'
import { Outlet } from "react-router-dom";
import Navi from './../Component/Nav/Nav';
import  Footer  from "../Component/Footer/Foot1";
import Wpp from "../Component/Wpp/Wpp"; 

const RootLayout = () => {

  useEffect(() => {
    window.scrollTo(0, 0);

  
    // Home Page Meta Tags
    document.title = 'Rushikesh Career Guidance: About Us | Get In Touch With Our Expert Counsellors | Home';

    // Set meta description dynamically
    const homeMetaDescription = document.createElement('meta');
    homeMetaDescription.name = 'description';
    homeMetaDescription.content = 'Expert guidance for medical and engineering aspirants with personalised counselling, smart college selection, and complete admission support.';
    document.head.appendChild(homeMetaDescription);

    // Set meta keywords dynamically
    const homeMetaKeywords = document.createElement('meta');
    homeMetaKeywords.name = 'keywords';
    homeMetaKeywords.content = 'NEET counselling near me, NEET admission counselling near me, NEET counsellor near me ,Medical admission guidance near me, NEET guidance center near me, Best NEET counsellor near me, NEET career guidance near me, MBBS admission counsellor near me, Medical college admission help near me, Maharashtra NEET counselling, Maharashtra MBBS admission guidance, State quota NEET counselling Maharashtra, NEET Maharashtra counselling expert, Maharashtra medical admission consultant,Private medical college admission Maharashtra, Government medical college admission guidance, RCG, RCG Counseling, Rushikesh Career Guidance';
    document.head.appendChild(homeMetaKeywords);

    // Set canonical link dynamically
    const homeCanonicalLink = document.createElement('link');
    homeCanonicalLink.rel = 'canonical';
    homeCanonicalLink.href = 'https://rcgcounselling.com/about';
    document.head.appendChild(homeCanonicalLink);

    // Set Open Graph title dynamically
    const homeOgTitle = document.createElement('meta');
    homeOgTitle.property = 'og:title';
    homeOgTitle.content = 'Rushikesh Career Guidance |  Home';
    document.head.appendChild(homeOgTitle);

    // Set Open Graph description dynamically
    const homeOgDescription = document.createElement('meta');
    homeOgDescription.property = 'og:description';
    homeOgDescription.content = 'Expert guidance for medical and engineering aspirants with personalised counselling, smart college selection, and complete admission support.';
    document.head.appendChild(homeOgDescription);

    // Set Open Graph URL dynamically
    const homeOgUrl = document.createElement('meta');
    homeOgUrl.property = 'og:url';
    homeOgUrl.content = 'https://rcgcounselling.com';
    document.head.appendChild(homeOgUrl);

    // Set Open Graph site name dynamically
    const homeOgSiteName = document.createElement('meta');
    homeOgSiteName.property = 'og:site_name';
    homeOgSiteName.content = 'Rushikesh Career Guidance';
    document.head.appendChild(homeOgSiteName);

    // Set Open Graph image dynamically
    const homeOgImage = document.createElement('meta');
    homeOgImage.property = 'og:image';
    homeOgImage.content = 'https://rcgcounselling.com/g1.jpg';
    document.head.appendChild(homeOgImage);

    // Set Open Graph secure image URL dynamically
    const homeOgImageSecure = document.createElement('meta');
    homeOgImageSecure.property = 'og:image:secure_url';
    homeOgImageSecure.content = 'https://rcgcounselling.com/g1.jpg';
    document.head.appendChild(homeOgImageSecure);

    // Set Open Graph image width dynamically
    const homeOgImageWidth = document.createElement('meta');
    homeOgImageWidth.property = 'og:image:width';
    homeOgImageWidth.content = '300';
    document.head.appendChild(homeOgImageWidth);

    // Set Open Graph image height dynamically
    const homeOgImageHeight = document.createElement('meta');
    homeOgImageHeight.property = 'og:image:height';
    homeOgImageHeight.content = '200';
    document.head.appendChild(homeOgImageHeight);


    // Add Twitter Card Tags
    const twitterCard = document.createElement('meta');
    twitterCard.name = 'twitter:card';
    twitterCard.content = 'summary_large_image';
    document.head.appendChild(twitterCard);

    const twitterTitle = document.createElement('meta');
    twitterTitle.name = 'twitter:title';
    twitterTitle.content = 'Rushikesh Career Guidance | Home';
    document.head.appendChild(twitterTitle);

    const twitterDescription = document.createElement('meta');
    twitterDescription.name = 'twitter:description';
    twitterDescription.content = 'Get In Touch With Our Expert Counsellors.';
    document.head.appendChild(twitterDescription);

    const twitterImage = document.createElement('meta');
    twitterImage.name = 'twitter:image';
    twitterImage.content = 'https://rcgcounselling.com/g1.jpg';
    document.head.appendChild(twitterImage);





    // Add Structured Data for Home Page
    const homeStructuredData = document.createElement('script');
homeStructuredData.type = 'application/ld+json';
homeStructuredData.textContent = JSON.stringify({
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": "Rushikesh Career Guidance",
  "telephone": "+917620582520",
              "contactType": "customer service",
               "areaServed": "IN",
                "availableLanguage": ["English", "Marathi", "Hindi"],
  "url": "https://rcgcounselling.com",
  "headline": "Rushikesh Career Guidance", // Add this line
  "potentialAction": {
    "@type": "SearchAction",
    "target": "https://rcgcounselling.com/search?query={search_term_string}",
    "query-input": "required name=search_term_string"
  },
  "description": "Rushikesh Career Guidance: About Us | Get In Touch With Our Expert Counsellors",
  "inLanguage": "en",
    "sitelinks": [
    {
      "@type": "WebPage",
      "name": "Home",
      "url": "https://rcgcounselling.com"
    },
    {
      "@type": "WebPage",
      "name": "Services",
      "url": "https://rcgcounselling.com/service"
    },
    {
      "@type": "WebPage",
      "name": "About Us",
      "url": "https://rcgcounselling.com/about"
    },
           {
      "@type": "WebPage",
      "name": "Portfolio",
      "url": "https://rcgcounselling.com/portfolio"
    },
    {
      "@type": "WebPage",
      "name": "Contact",
      "url": "https://rcgcounselling.com/Contact"
    }
  ]
});

    document.head.appendChild(homeStructuredData);

    // Cleanup on component unmount
    return () => {
      document.title = 'Rushikesh Career Guidance: About Us | Get In Touch With Our Expert Counsellors | Home';
      document.head.removeChild(homeMetaDescription);
      document.head.removeChild(homeMetaKeywords);
      document.head.removeChild(homeCanonicalLink);
      document.head.removeChild(homeOgTitle);
      document.head.removeChild(homeOgDescription);
      document.head.removeChild(homeOgUrl);
      document.head.removeChild(homeOgSiteName);
      document.head.removeChild(homeOgImage);
      document.head.removeChild(homeOgImageSecure);
      document.head.removeChild(homeOgImageWidth);
      document.head.removeChild(homeOgImageHeight);
      document.head.removeChild(homeStructuredData);
    };

  }, []);



    return <div>
 
        <Navi></Navi>
         
        <Outlet></Outlet>
        <Wpp></Wpp>
         <Footer></Footer>
         
    </div>
};

export default RootLayout;